import { SupportedApplication } from "@/../nft-client/dist/whiteLabel";

export function getApplicationModeFromStorage() {
    return globalThis?.localStorage?.getItem("application");
}

export function setApplicationModeToLocalStorage(mode: SupportedApplication) {
    globalThis?.localStorage?.setItem("application", mode);
}
